(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-sibling-swatches-sanola"] && !Shopify.designMode) return;
  try {
    const siblingSwatchBlocks = document.querySelectorAll('[data-sibling-swatches]');
  siblingSwatchBlocks.forEach((block) => {
    const label = block.querySelector('[data-sibling-swatches-current]');
    if (!label) return;
    const defaultLabel = block.dataset.defaultLabel || label.textContent || '';
    const links = block.querySelectorAll('[data-color-label]');

    const setLabel = (value) => {
      label.textContent = value || defaultLabel;
    };

    links.forEach((link) => {
      const colorLabel = link.dataset.colorLabel || '';
      link.addEventListener('pointerenter', () => setLabel(colorLabel));
      link.addEventListener('focus', () => setLabel(colorLabel));
      link.addEventListener('pointerleave', () => setLabel(defaultLabel));
      link.addEventListener('blur', () => setLabel(defaultLabel));
    });
  });
  } catch(e) { console.error(e); }
})();

})();
